import { render, staticRenderFns } from "./SmartCaptcha.vue?vue&type=template&id=4c6fb563&"
import script from "./SmartCaptcha.vue?vue&type=script&lang=ts&"
export * from "./SmartCaptcha.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports